ExternalLinks = window.ExternalLinks ?={}

isMailToLink = (obj) ->
  obj.href.match(/^mailto\:/)

isLinkToPdf = (obj) ->
  /.pdf$/.test(obj.href)

isLinkToJs = (obj) ->
  obj.href.match(/^javascript\:/)

isLinkToEmptyUrl = (obj) ->
  obj.href.match(/^$/)

isLinkToExternalUrl = (obj) ->
  obj.hostname isnt location.hostname and obj.hostname.indexOf("groupon.com") is -1

isWhiteListedLink = (obj) ->
  selectors = ['.fine-print a']
  $obj = $(obj)
  return true for selector in selectors when $obj.is(selector)
  return false

isBlackListedLink = (obj) ->
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy']
  $obj = $(obj)
  return true for selector in selectors when $obj.is(selector)
  return false

$.expr[":"].external = (obj, index, meta, stack) ->
  (isLinkToExternalUrl(obj) or isLinkToPdf(obj) or isWhiteListedLink(obj)) and not (isMailToLink(obj) or isLinkToJs(obj) or isLinkToEmptyUrl(obj) or isBlackListedLink(obj))

ExternalLinks.init = (payload, done) ->
  $ ->
    $("a:external").click (e) ->
      e.preventDefault()
      window.open $(this).attr('href'), "_blank"

    done()


module.exports = ExternalLinks
